/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';
import { CoreUiExtTreeModule } from '@gh/core-ui-ext/tree';
import { BuilderSetupJobAdminRoutingModule } from './builder-setup-job-admin-routing.module';
import { CSMasterCloneDialogComponent } from './components/cs-master-clone-dialog/cs-master-clone-dialog.component';
import { CsMasterDetailCCFormComponent } from './components/cs-master-details/cs-master-detail-cc-form/cs-master-detail-cc-form.component';
import { CsMasterDetailHeadingFormComponent } from './components/cs-master-details/cs-master-detail-heading-form/cs-master-detail-heading-form.component';
import { CsMasterDetailItemFormComponent } from './components/cs-master-details/cs-master-detail-item-form/cs-master-detail-item-form.component';
import { CsMasterDetailSubHeadingFormComponent } from './components/cs-master-details/cs-master-detail-sub-heading-form/cs-master-detail-sub-heading-form-form.component';
import { CSMasterDetailsTopFormComponent } from './components/cs-master-details/cs-master-details-top-form/cs-master-details-top-form.component';
import { CSMasterDetailsComponent } from './components/cs-master-details/cs-master-details.component';
import { CSMasterListTabComponent } from './components/cs-master-list/cs-master-list-tab.component';
import { JobAdminTabContainerComponent } from './components/job-admin-tab-container/job-admin-tab-container.component';
import { JobLetterListTabComponent } from './components/job-letter-list-tab/job-letter-list-tab.component';
import { JobSpecTemplateDetailsComponent } from './components/job-spec-template-details/job-spec-template-details.component';
import { JstDetailsTopFormComponent } from './components/job-spec-template-details/jst-details-top-form/jst-details-top-form.component';
import { JstParagraphFormComponent } from './components/job-spec-template-details/jst-paragraph-form/jst-paragraph-form.component';
import { JstSectionClauseListComponent } from './components/job-spec-template-details/jst-section-clause-list/jst-section-clause-list.component';
import { JstSectionFormComponent } from './components/job-spec-template-details/jst-section-form/jst-section-form.component';
import { JobSpecTemplateListTabComponent } from './components/job-spec-template-list-tab/job-spec-template-list-tab.component';
import { JobStageListTabComponent } from './components/job-stage-list-tab/job-stage-list-tab.component';
import { CSMasterBusinessService } from './resources/cs-master-business.service';
import { JobLetterListTabBusinessService } from './resources/job-letter-list-tab-business.service';
import { JobSpecTemplateDetailsBusinessService } from './resources/job-spec-template-details-business.service';
import { JobSpecTemplateListTabBusinessService } from './resources/job-spec-template-list-tab-business.service';
import { JobStageListBusinessService } from './resources/job-stage-list-business.service';

@NgModule({
  imports: [
    DragDropModule,
    CoreUiExtSplitPaneModule,
    BuilderSharedModule.forChild(),
    CoreUiExtTreeModule,
    BuilderSetupJobAdminRoutingModule,
  ],
  providers: [
    JobLetterListTabBusinessService,
    JobSpecTemplateListTabBusinessService,
    JobSpecTemplateDetailsBusinessService,
    CSMasterBusinessService,
    JobSpecTemplateDetailsBusinessService,
    JobStageListBusinessService,
  ],
  declarations: [
    JobAdminTabContainerComponent,
    JobLetterListTabComponent,
    JobSpecTemplateListTabComponent,
    JobSpecTemplateDetailsComponent,
    JstDetailsTopFormComponent,
    JstParagraphFormComponent,
    JstSectionFormComponent,
    JstSectionClauseListComponent,
    JobStageListTabComponent,
    CSMasterListTabComponent,
    CSMasterCloneDialogComponent,
    CSMasterDetailsComponent,
    CSMasterDetailsTopFormComponent,
    CsMasterDetailHeadingFormComponent,
    CsMasterDetailSubHeadingFormComponent,
    CsMasterDetailItemFormComponent,
    CsMasterDetailCCFormComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})
export class BuilderSetupJobAdminModule {
}
